/**
 * WARNING
 *
 * Do not add anything here. Feel free to delete things.
 * New things should only be added to angularjs apps.
 * See webapp-ajs to see how routes match to specific modules.
 *
 */

import '../components/ace-textarea/ace-textarea-component';
import '../components/auto-height/auto-height-directive';
import '../components/calc-editor-modal/calc-editor-modal.component';
import '../components/calc-editor-modal/calculated-field-view.component';
import '../components/calc-editor-modal/calc-editor.component';
import '../components/calc-editor-modal/formula-editor.component';
import '../components/calc-editor-modal/formula-reference.component';
import '../components/chart-selector/multi-select';
import '../components/chart-selector/select-height-directive';
import '../components/code-highlight/code-highlight-directive';
import '../components/code-highlight/live-code-highlight-directive';
import '../components/console/console-component';
import '../components/console/console-line-component';
import '../components/data-source-banner/data-source-banner-component';
import '../components/data-source-connector/host-port-field-formatter-directive';
import '../components/data-source-connector/http-endpoint-default-setter-directive';
import '../components/db-help-panel/db-help-panel-component';
import '../components/db-help-panel/db-invite-inline-form';
import '../components/db-help-panel/direct-connect-component';
import '../components/editor-settings-dropdown-menu/editor-settings-dropdown-menu-component';
import '../components/empty-notebook/empty-notebook';
import '../components/focus-me/focus-me-directive';
import '../components/form-email-an-admin/form-email-an-admin.component';
import '../components/format-settings/format-settings';
import '../components/group-membership/group-membership-component';
import '../components/group-membership/group-membership-directive';
import '../components/groups/group-facepile-component';
import '../components/groups/group-show-component';
import '../components/header/nav-flyout-component';
import '../components/header/sharing-banner-component';
import '../components/header/simple-header-component';
import '../components/instrumentation/connect-db-instrumentation-directive';
import '../components/intercom/intercom-show';
import '../components/interstitial-email-an-admin/interstitial-email-an-admin';
import '../components/modal-clone/clone-modal-directive';
import '../components/modal-confirm/confirm-modal-directive';
import '../components/modal-context/context-modal-directive';
import '../components/modal-create-definition/create-definition-directive';
import '../components/modal-create-definition/rename-definition-directive';
import '../components/modal-create-group/create-group-directive';
import '../components/modal-create-group/rename-group-directive';
import '../components/modal-create-org/create-org-modal-directive';
import '../components/modal-create-space/create-space-directive';
import '../components/modal-create-space/rename-space-directive';
import '../components/modal-create-space/space-name-validation-directive';
import '../components/modal-delete-report/delete-report-modal-directive';
import '../components/modal-dialog-prompt/dialog-prompt-modal-directive';
import '../components/modal-email-an-admin/modal-email-an-admin';
import '../components/modal-embed/embed-component';
import '../components/modal-embed/embed-modal-directive';
import '../components/modal-move-space/move-space-directive';
import '../components/modal-move-space/remove-shortcut-directive';
import '../components/modal-move-space/shortcut-space-directive';
import '../components/modal-pdf-export/pdf-export-modal-directive';
import '../components/modal-rename-query/rename-query-modal-directive';
import '../components/modal-rename-report/rename-report-modal-directive';
import '../components/modal-rename/rename-modal-directive';
import '../components/modal-report-settings/report-settings-component';
import '../components/modal-report-settings/report-settings-directive';
import '../components/modal-save-alert/save-alert-modal-directive';
import '../components/modal-sql-settings/modal-sql-settings-component';
import '../components/modal-sql-settings/modal-sql-settings-directive';
import '../components/modal-switch-to-org/switch-to-org-modal-directive';
import '../components/mode-enter/mode-enter';
import '../components/ospicker/os-item-component';
import '../components/ospicker/os-picker-component';
import '../components/payment-info-validator/payment-info-validator';
import '../components/pivot-table/pivot-resize-directive';
import '../components/platform-header-nav-panel/platform-header-nav-panel-component';
import '../components/platform-header-nav/platform-header-nav-component';
import '../components/platform-header/platform-header-component';
import '../components/report-history/report-history-component';
import '../components/report-list/report-drag-directive';
import '../components/report-list/report-drop-directive';
import '../components/report-parameters/report-parameter-field-component';
import '../components/report-parameters/report-parameters-component';
import '../components/report-parameters/report-run-button-component';
import '../components/schedules/new-schedules-component';
import '../components/schedules/schedules-list-directive';
import '../components/select-db-connect/db-skip-component';
import '../components/select-db-connect/db-typeahead-selector-component';
import '../components/select-db-connect/select-db-connect-component';
import '../components/select-db-connect/selector-item-component';
import '../components/select-db-connect/selector-list-component';
import '../components/select-navigator/select-navigator-directive';
import '../components/select-on-click/select-on-click-directive';
import '../components/session-timeout-input/session-timeout-input';
import '../components/signup-email-input/signup-email-input-component';
import '../components/space-membership/space-membership-component';
import '../components/space-membership/space-membership-directive';
import '../components/status-bar/status-bar';
import '../components/status-bar/status-loader-component';
import '../components/sticky-header/sticky-header-directive';
import '../components/table-designer/table-designer.component';
import '../components/table-designer/table-sidebar.component';
import '../components/tiled-panes/tiled-panes';
import '../components/tokenfield/tokenfield-directive';
import '../components/trial-banner/trial-banner-component';
import '../components/upload-file/upload-file-component';
import '../components/validators/presto-port-validator-directive';
import '../components/validators/sqlserver-instance-validator';
import '../components/view-data-lightbox/view-data-lightbox-modal-component';
import '../components/viz-lightbox/lightbox-header-component';
import '../components/viz-lightbox/viz-container-component';
import '../modules/mode-components';

import * as angular from 'angular';

import { ReportViewerComponent } from '../components/embed-frame/report-viewer.component';
import { FeatureNuxtComponent } from '../components/feature-nuxt/feature-nuxt.component';
import { FlamingoErrorComponent } from '../components/flamingo-results-grid/flamingo-error.component';
import { FlamingoViewDataGridComponent } from '../components/view-data-grid/flamingo-view-data-grid-component';
import { PivotResultsDataGridComponent } from '../components/view-data-grid/pivot-results-data-grid.component';
import { CreateDefinitionModalComponent } from '../components/modal-create-definition/create-definition-modal.component';
/**
 * @deprecated No new components should be added. Please add to specific app modules.
 */
export const ComponentsModule = angular
  .module('mode.components')
  .component('reportViewer', ReportViewerComponent)
  .component('flamingoViewDataGrid', FlamingoViewDataGridComponent)
  .component('pivotResultsDataGrid', PivotResultsDataGridComponent)
  .component('createDefinitionModal', CreateDefinitionModalComponent)
  .component('flamingoError', FlamingoErrorComponent)
  .component('featureNuxt', FeatureNuxtComponent).name;
